import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { MwcButtonModule } from 'mwc/button';
import { CommonModule } from '@angular/common';
import { StorageHelper } from '../_utilities/storage-helper';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { TokenService } from '../services/token/token.service';

/**
 * Full-page screen shown when this tab is an older instance of a single-profile session that a
 * newer tab has taken over. Reuses the session-expired screen's visual language. OK sends the
 * user to MPC / suite home. Reached via the /newer-session route (see SessionInstanceService).
 */
@Component({
  selector: 'app-newer-session',
  standalone: true,
  imports: [CommonModule, MwcButtonModule],
  templateUrl: './newer-session.component.html',
  styleUrls: ['./newer-session.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewerSessionComponent {
  private _storageHelper: StorageHelper;
  constructor(private router: Router, private tokenService: TokenService) {
    this._storageHelper = new StorageHelper();
  }

  async ok(): Promise<void> {
    // Redirect to MPC / suite home (mirrors SessionExpiredComponent's recovery path).
    const returnUrl = this._storageHelper.user?.returnUrl || '';
    if (returnUrl) {
      window.location.href = returnUrl;
      return;
    }
    // No stored returnUrl -> fall back to the anonymous endpoint that resolves the MPC base URL.
    try {
      const result = await lastValueFrom(this.tokenService.getBaseReturnUrl());
      if (result?.url) {
        window.location.href = result.url;
        return;
      }
    } catch (error) {
      console.error('Failed to fetch return url:', error);
    }
    this.router.navigate(['auth']);
  }
}
